var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var baseTenant = {
    language: "en-GB",
    Etag: "",
    groupId: null,
    locale: "en-GB",
    settings: {
        featureFlags: "",
        color: "#800080",
        textColor: "#fff",
        imageLink: "https://res.cloudinary.com/perkbox/image/upload/v1524747023/2811db0a-3811-42d0-804b-ab74e73f00bb.png",
        welcomeEmail: "",
        signUpOption: "none",
        showSSOOptions: false,
        hideNormalLogin: false,
        employeeName: null,
        ssoButtonText: ""
    }
};
var generateNewTenant = function (tenant) { return (__assign(__assign({}, baseTenant), { subdomain: tenant, public_name: tenant })); };
export default generateNewTenant;
